import React from "react";
import { cn } from "../../../../../../lib/utils";

interface SearchFieldProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  variant?: "default" | "filled" | "outline";
  size?: "sm" | "md" | "lg";
}

const searchFieldSizes = {
  sm: "h-8",
  md: "h-9",
  lg: "h-10",
};

const searchFieldVariants = {
  default:
    "box-border border border-semantic-secondary-stroke-normal-default hover:border-semantic-secondary-stroke-normal-hovered focus-within:border-semantic-secondary-stroke-normal-pressed",
  filled:
    "box-border bg-semantic-secondary-background-normal-default border border-semantic-secondary-stroke-normal-default hover:border-semantic-secondary-stroke-normal-hovered focus-within:border-semantic-secondary-stroke-normal-pressed",
  outline:
    "box-border border-2 border-semantic-secondary-stroke-normal-default hover:border-semantic-secondary-stroke-normal-hovered focus-within:border-semantic-secondary-stroke-normal-pressed",
};

const SearchField = React.forwardRef<HTMLDivElement, SearchFieldProps>(
  (
    { className, children, variant = "default", size = "md", ...props },
    ref
  ) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex w-full items-center rounded-sm transition-all duration-200",
          searchFieldVariants[variant],
          searchFieldSizes[size],
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

SearchField.displayName = "SearchField";

export { SearchField };
export type { SearchFieldProps };
